import { ComponentProps, Suspense, useCallback } from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { Loader } from '../Loader/Loader';

/**
 * Routes to a lazy-loaded component with an automatic loading indicator
 */
export const LazyRoute = ({
  component: RoutedComponent,
  ...routeProps
}: Omit<ComponentProps<typeof Route>, 'children'> & {
  component: NonNullable<ComponentProps<typeof Route>['component']>;
}) => {
  const Lazy = useCallback(
    (props: RouteComponentProps) => {
      return (
        <Suspense fallback={<Loader loading />}>
          <RoutedComponent {...props} />
        </Suspense>
      );
    },
    [RoutedComponent]
  );

  return <Route {...routeProps} component={Lazy} />;
};
